import hostOf from '../hostOf';
import protocolOf from '../protocolOf';

const baseUrlOf = req => {
  return `${protocolOf(req)}//${hostOf(req)}`;
};

export default baseUrlOf;
